import { NgModule, APP_INITIALIZER } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { AppComponent } from './app.component';
import { CoreModule } from '@app/core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '@env/environment';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader, MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppLoadService } from './app-load.service';
import { MessageBoxComponent } from '@app/core/dialogs/message-box/message-box.component';
import { FormsComponent } from '@app/core/dialogs/forms/forms.component';
import { PdfDownloadComponent } from '@app/core/dialogs/pdf-download/pdf-download.component';
import { AppearanceComponent } from '@app/core/dialogs/appearance/appearance.component';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return params.translateService.parser.interpolate(params.key, params.interpolateParams);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n/', '/messages.json' + '?v=' + environment.version);
}

export function appLoad(appLoadService: AppLoadService) {
  return () => appLoadService.load();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    HttpClientModule,
    TranslateModule.forRoot({
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MyMissingTranslationHandler },
      // useDefaultLang: false,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    CoreModule,
  ],
  exports: [AppComponent],
  entryComponents: [MessageBoxComponent, FormsComponent, PdfDownloadComponent, AppearanceComponent],
  providers: [
    {
      provide: APP_BASE_HREF,
      useValue: '/',
    },
    AppLoadService,
    {
      provide: APP_INITIALIZER,
      useFactory: appLoad,
      deps: [AppLoadService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
